import { RootStateOrAny, useSelector } from 'react-redux';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { GridReadyEvent } from 'ag-grid-community';
import { useGetUsersQuery } from '../../../services/organizations/organizations.service';
import { skipToken } from '@reduxjs/toolkit/query';

const useUsersGrid = () => {
    const history = useHistory();

    const user = useSelector((state: RootStateOrAny) => state.user);
    const [gridApi, setGridApi] = useState(null);
    const { data: rowData, isLoading: isLoading } = useGetUsersQuery(
        user?.businessEntity?.id
            ? user?.businessEntity?.id.toString()
            : skipToken
    );

    const [gridColumnApi, setGridColumnApi] = useState(null);

    const onGridReady = (params: GridReadyEvent) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const redirectToForm = (row: any) => {
        if (row.id) {
            history.push(`/administration/organizations/users/${row.id}`);
        } else {
            history.push('/administration/organizations/users/new');
        }
    };

    return {
        onGridReady,
        rowData,
        isLoading,
        redirectToForm,
    };
};

export default useUsersGrid;
